import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Notification } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditStatus } from '../edit-view/EditView';

export const NotificationForEditStatus: React.FC<{ editStatus: EditStatus }> = ({ editStatus }) => {
    const { t } = useTranslation('my-profile');

    switch (editStatus) {
        case EditStatus.SUCCESS: {
            return (
                <Notification
                    status={NotificationStatus.success}
                    title={t('contact-details.notification.success.title')}
                    testId={'editStatus'}
                    visible
                    showCloseButton={false}
                >
                    {t('contact-details.notification.success.content')}
                </Notification>
            );
        }
        case EditStatus.ALREADY_IN_PROGRESS: {
            return (
                <Notification
                    status={NotificationStatus.warning}
                    testId={'editStatus'}
                    title={''}
                    hideTitle={true}
                    visible
                    showCloseButton={false}
                >
                    {t('contact-details.notification.already-in-progress')}
                </Notification>
            );
        }
        case EditStatus.ERROR: {
            return (
                <Notification
                    status={NotificationStatus.error}
                    testId={'editStatus'}
                    title={''}
                    hideTitle={true}
                    visible
                    showCloseButton={false}
                >
                    {t('contact-details.notification.error')}
                </Notification>
            );
        }
        default: {
            return null;
        }
    }
};
